import { defineMessages } from 'react-intl';

export default defineMessages({
    VehicleIncidentsQuestion: {
        id: 'wni.fnol.ho.views.incidentdetails.vehicleIncidents.question',
        defaultMessage: "Were there any third party vehicle damages?"
    },
    Yes: {
        id: 'wni.fnol.ho.views.incidentdetails.vehicleIncidents.Yes',
        defaultMessage: "Yes"
    },
    No: {
        id: 'wni.fnol.ho.views.incidentdetails.vehicleIncidents.No',
        defaultMessage: "No"
    },
    Number: {
        id: 'wni.fnol.ho.views.incidentdetails.vehicleIncidents.No.',
        defaultMessage: "No."
    },
    VehicleOwner: {
        id: 'wni.fnol.ho.views.incidentdetails.vehicleIncidents.VehicleOwner',
        defaultMessage: "Vehicle Owner"
    },
    VehicleLocation: {
        id: 'wni.fnol.ho.views.incidentdetails.vehicleIncidents.VehicleLocation',
        defaultMessage: "Vehicle Location"
    },
    Edit: {
        id: 'wni.fnol.ho.views.incidentdetails.vehicleIncidents.Edit',
        defaultMessage: "Edit"
    },
    Delete: {
        id: 'wni.fnol.ho.views.incidentdetails.vehicleIncidents.Delete',
        defaultMessage: "Delete"
    },
    AddVehicle: {
        id: 'wni.fnol.ho.views.incidentdetails.vehicleIncidents.AddVehicle',
        defaultMessage: "Add Vehicle"
    }
})